import Vue from 'vue'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing, {
  networks: {
    instagram: 'https://www.instagram.com/sharer/sharer.php??url=@url&title=@title'
  }
})

export default VueSocialSharing